<template>
	<div name="hres35u-popup-approve" id="hres35u-popup-approve" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal" ref="popupApproveModalButton">&times;</button>
          <h4 class="modal-title">{{ labels['HRES35UC2']['0'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">	
        	<div class="detail detail-responsive">

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES35UC2']['10'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="coddesc_codempid" name="coddesc_codempid">{{ approve.codempid }}{{ approve.desc_codempid }}</div>
						  </div>
						</div>
            <!-- Approvno -->
            <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES35UC2']['20'] }}</div>
              <div class="detail-right">
                  <div class="detail-text width-70" id="approvno" name="approvno">{{ indexSelected.approvno }}</div>
              </div>
            </div>
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES35UC2']['30'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="coddesc_codappr" name="coddesc_codappr">{{ approve.codappr }}{{ approve.desc_codappr }}</div>
						  </div>
						</div>
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES35UC2']['40'] }}</div>
						  <div class="detail-right">
					      <div class="input-group width-70">
                  <hrms-datepicker  v-model="currentDate"
                                    v-show="false"
                                    v-validate="'required|date_format:DD/MM/YYYY'"
                                    data-vv-value-path="inputDate"
                                    name="currentDate"
                                    :has-error="errors.has('currentDate')" />
                  <hrms-datepicker  v-model="approve.dteappr"
                                    v-validate="'required|date_format:DD/MM/YYYY|after:currentDate'"
                                    data-vv-value-path="inputDate"
                                    name="dteappr"
                                    :has-error="errors.has('dteappr')" />
                  <div class="text-error" v-show="errors.has('dteappr')">{{errors.first('dteappr')}}</div>	
					      </div> 
						  </div>
						</div>
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES35UC2']['50'] }}</div>
						  <div class="detail-right">
					      <div class="input-group width-70">
					      	<hrms-datepicker  v-model="approve.dteeffec"
                                    v-validate="'required|date_format:DD/MM/YYYY|after:dteappr'"
                                    data-vv-value-path="inputDate"
                                    name="dteeffec"
                                    :has-error="errors.has('dteeffec')" />
                  <div class="text-error" v-show="errors.has('dteeffec')">{{errors.first('dteeffec')}}</div>	
					      </div> 
						  </div>
						</div>
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES35UC2']['60'] }}</div>
						  <div class="detail-right">
						  	<div class="input-group width-70">
						  		<hrms-dropdown  v-model="approve.codmov" 
                                  :options="arrCodmov[nowLang]"
                                  v-validate="'required'"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="codmov"
                                  :has-error="errors.has('codmov')" />
                  <div class="text-error" v-show="errors.has('codmov')">{{errors.first('codmov')}}</div>
						  	</div>
						  </div>
						</div>
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES35UC2']['70'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="status" name="status">{{ approve.status }}</div>
						  </div>
						</div>                      
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES35UC2']['110'] }}</div>
						  <div class="detail-right">
                  <textarea class="textarea-text width-70"
                            v-model="approve.remark" 
                            id="remark" 
                            name="remark"
                            maxlength="500" 
                            v-validate="'max:500'"
                            data-vv-name="remark"
                            :has-error="errors.has('remark')"  ></textarea>
                  <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
                  <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div> 
							</div>
						</div>   
	
        	</div>			
        </div>

        <div class="modal-footer align-center border-color-skin">
          <button type="button" class="btn bg-green" @click="validatePopupApprove()" ><i class="fa fa-check-circle"></i> {{ labelsButton['approve'] }}</button>
        </div>

	    </div>
    </div>
	</div>
</template>

<script>
import moment from 'moment'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres35u-popup-approve',
  data () {
    return {
      approve: {
        staappr: '',
        flgStaappr: '',
        approvno: 0,
        chk_appr: '',
        numseq: '',
        codempid: '',
        dtereq: '',
        dteappr: '',
        dteeffec: '',
        codmov: '',
        remark: '',
        desc_codempid: '',
        desc_codappr: '',
        desc_codmov: '',
        status: '',
        codappr: ''
      },
      currentDate: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    if (typeof this.arrCodmov[this.nowLang][this.approve.codmov] === 'undefined') {
      this.approve.codmov = ''
    }
  },
  watch: {
    indexSelected () {
      this.approve = {
        staappr: this.indexSelected.staappr,
        flgStaappr: this.indexSelected.flgStaappr,
        approvno: this.indexSelected.approvno,
        chk_appr: this.indexSelected.chk_appr,
        numseq: this.indexSelected.numseq,
        codempid: this.indexSelected.codempid,
        dtereq: this.indexSelected.dtereq,
        dteappr: moment().format('DD/MM/YYYY'),
        dteeffec: this.indexSelected.dtereq,
        codmov: '',
        remark: '',
        desc_codempid: this.indexSelected.desc_codempid,
        desc_codappr: this.descCodappr,
        desc_codmov: '',
        status: this.indexSelected.status,
        codappr: this.codappr
      }
      this.$nextTick(function () {
        this.errors.clear()
      })
    }
  },
  props: [ 'labels', 'nowLang', 'postHres35uSendApprove', 'indexSelected', 'codappr', 'descCodappr', 'arrCodmov', 'labelsButton' ],
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    validatePopupApprove () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres35uSendApprove(this.sendApprove())
        }
      })
    },
    sendApprove () {
      return {
        approveParams: this.approve,
        referenceButton: this.$refs.popupApproveModalButton
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// popupApprove.vue?04f5d971